import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;

// Client is null until Sanity is configured — blog pages fall back to mock data
export const client = projectId
  ? createClient({
      projectId,
      dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
      useCdn: true,
      apiVersion: '2024-01-01',
    })
  : null;

const builder = client ? imageUrlBuilder(client) : null;

export function urlFor(source) {
  if (!builder) return { width: () => ({ url: () => '' }), url: () => '' };
  return builder.image(source);
}
